import $ from 'jquery';

export default function init() {
    var $toggle = $('.js-toggle-main-navigation');
    var $header = $('.site-header');
    var $nav = $('.js-main-navigation-wrapper');
    var $hideables = $('.js-site-content, .js-main-footer');

    var $toggleSearchBar = $('.js-toggle-search-bar');
    var $searchBar = $('.js-search-bar-wrapper');

    var $toggleLanguageSelector = $('.js-toggle-language-selector');
    var $languageSelector       = $('.js-language-selector__container-mobile');

    var $toggleSub = $('.js-toggle-sub-navigation');
    var $subNavs = $('.navigation__sub');

    var $toggleReadingList = $('.js-toggle-reading-list');
    var $readingList = $('.js-reading-list-wrapper');

    var currentUrl = location.origin + location.pathname;
    $nav.find('a[href="' + currentUrl + '"]').addClass('active').closest('.js-nav-parent-container').find('.js-nav-parent').addClass('active');

    $toggle.on('click', function (e) {
        e.preventDefault();

        if ($nav.hasClass('active')) {
            $('.site-footer').show() //fix footer visible over open menu
            closeNav($hideables, $toggle, $nav, $toggleSub, $subNavs, $header);
        } else {
            $('.site-footer').hide() //fix footer visible over open menu
            $hideables.fadeOut(100);
            $toggle.addClass('active').attr('aria-expanded', true);
            $nav.addClass('active');
            $header.addClass('navigation-is-open');

            $searchBar.removeClass('active');
            $toggleSearchBar.removeClass('active').attr('aria-expanded', false);
            $searchBar.hide();

            $toggleLanguageSelector.removeClass('active').attr('aria-expanded', false);
            $languageSelector.hide();

            $readingList.removeClass('active');
            $toggleReadingList.removeClass('active').attr('aria-expanded', false);

            $(document).on('keyup.closeNav', function(e) {
                if (e.keyCode === 27) { // esc
                    closeNav($hideables, $toggle, $nav, $toggleSub, $subNavs, $header);
                }
            });
        }
    });

    $toggleSub.on('click', function name(e) {
        e.preventDefault();

        var $el = $(this);
        $el.attr('aria-expanded', $el.attr('aria-expanded') !== 'true');
        $el.toggleClass('active');

        var target = $(this).data('toggle');
        var $target = $('#' + target);
        $target.slideToggle(400, function() {
            $(this).css('display', '').toggleClass('active');
        });
    });
}

function closeNav($hideables, $toggle, $nav, $toggleSub, $subNavs, $header) {
    $hideables.fadeIn(100);
    $toggle.removeClass('active').attr('aria-expanded', false).delay(100).focus();
    $nav.removeClass('active');
    $header.removeClass('navigation-is-open');
    $toggleSub.removeClass('active').attr('aria-expanded', false);
    $subNavs.css('display', '').removeClass('active');
    $(document).off('keyup.closeNav');
}
